module.exports = __webpack_public_path__ + "img/speech-icon.3ec44757.svg";